import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './SideBarComponent.scss';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
function SideBarComponent({
  heading,
  subHeading = null,
  subHeadingStyle = {},
  ContainerComponent,
  isCollapsible,
  handleColapse,
  isCollapsedFirstTime = false,
}) {
  const [collapseContainer, setCollapseContainer] = useState(isCollapsedFirstTime);

  function handleCollapseToggle() {
    setCollapseContainer((prevState) => !prevState);
    handleColapse(!collapseContainer);
  }

  function getColapseArrow() {
    const Icon = collapseContainer ? BiChevronDown : BiChevronUp;
    return (
      <div
        id='sidebarcomponent-colapse-arrow-toggle'
        className="relative inline-flex items-center justify-center w-8 h-8 rounded-full bg-black cursor-pointer"
        onClick={handleCollapseToggle}
      >
        <Icon id='sidebarcomponent-colapse-arrow-toggle-icon' className="text-white" size="80%" />
      </div>
    );
  }

  return (
    <div
      id='sidebarcomponent-wrapper'
      style={{
        flex: 1,
        flexDirection: 'column',
        width: '100%',
        marginBottom: '0.1%',
      }}
    >
      <div id='sidebarcomponent-heading' className="group-heading-div">
        <div
          style={{ width: '90%' }}
          className="side-bar-component-heading Command-Panel-Heading text-transform"
        >
          {heading}
          {subHeading && <span style={subHeadingStyle}>{subHeading}</span>}
        </div>
        {isCollapsible ? (
          <div
            id='sidebarcomponent-collapse-arrow'
            style={{
              height: '100%',
              width: '3vw',
              alignItems: 'center',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            {getColapseArrow()}
          </div>
        ) : null}
      </div>
      <Collapse
        in={isCollapsible == false ? true : !collapseContainer}
        className="group-visible"
      >
        <div id='sidebarcomponent-collapse-container'
          style={{
            width: '100%',
          }}
        >
          {ContainerComponent}
        </div>
      </Collapse>
    </div>
  );
}

export default SideBarComponent;
